<template>
    <div>
        <nav aria-label="Page navigation">
            <ul class="pagination">
                <li>
                    <a aria-label="İlk Sayfa" @click.prevent="changePage(1)" :disabled="pagination.current_page <= 1">
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>
                <li v-for="page in pages" :key="page.index">
                    <a :class="isCurrentPage(page) ? 'is-current' : ''" @click.prevent="changePage(page)">{{ page }}</a>
                </li>
                <li>
                    <a href="#" aria-label="İleri"  @click.prevent="changePage(pagination.last_page)" :disabled="pagination.current_page >= pagination.last_page">
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<style scoped>
    .pagination {
        margin-top: 40px;
    }
    .is-current{
        background-color: #23527c;
        color: #fff;
        border-color: #23527c;
    }
</style>

<script>
    export default {
        props: ['pagination', 'offset'],
        methods: {
            isCurrentPage(page) {
                return this.pagination.current_page === page;
            },
            changePage(page) {
                if (page > this.pagination.last_page) {
                    page = this.pagination.last_page;
                }
                this.pagination.current_page = page;
                this.$emit('paginate');
            }
        },
        computed: {
            pages() {
                let pages = [];
                let from = this.pagination.current_page - Math.floor(this.offset / 2);
                if (from < 1) {
                    from = 1;
                }
                let to = from + this.offset - 1;
                if (to > this.pagination.last_page) {
                    to = this.pagination.last_page;
                }
                while (from <= to) {
                    pages.push(from);
                    from++;
                }
                return pages;
            }
        }
    }
</script>